import { render, staticRenderFns } from "./ScopeSummary.vue?vue&type=template&id=63664a45&"
import script from "./ScopeSummary.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ScopeSummary.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports